import { useMemo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { absUrl } from "./aiApi";
import AIChart from "./AIChart";

const REMARK = [remarkGfm];

export default function AIMarkdown({ children, onImage, onOpenDoc }) {
  // Komponen distabilkan (useMemo) supaya carta/gambar tidak di-mount semula pada setiap render
  const components = useMemo(() => ({
          a: ({ href, children: c }) => {
            const label = String(Array.isArray(c) ? c.join("") : c || "");
            const isDocx = onOpenDoc && (href || "").includes("/api/ai/files/") && /\.docx\b/i.test(label);
            return (
              <>
                <a href={absUrl(href)} target="_blank" rel="noreferrer" className="text-fuchsia-600 font-semibold underline underline-offset-2 hover:text-fuchsia-700">{c}</a>
                {isDocx && (
                  <button type="button" onClick={() => onOpenDoc({ url: href, filename: label.replace(/^Muat turun\s+/i, "") })} data-testid="ai-md-open-docx"
                    className="ml-1.5 align-middle h-6 px-2 rounded-full bg-sky-50 border border-sky-200 text-sky-700 text-[10.5px] font-bold hover:bg-sky-100">Buka</button>
                )}
              </>
            );
          },
          img: ({ src, alt }) => (
            <button type="button" onClick={() => onImage && onImage(absUrl(src))} className="inline-block m-1 align-top" data-testid="ai-md-image">
              <img src={absUrl(src)} alt={alt || "gambar"} loading="lazy" className="h-28 w-28 object-cover rounded-xl border border-white shadow-md hover:scale-[1.03] transition-transform" />
            </button>
          ),
          table: ({ children: c }) => (
            <div className="overflow-x-auto my-3 rounded-2xl border border-amber-100 bg-white"><table className="min-w-full text-xs">{c}</table></div>
          ),
          th: ({ children: c }) => <th className="bg-amber-50/80 px-3 py-2 text-left text-[11px] font-extrabold uppercase tracking-wider text-amber-900 whitespace-nowrap">{c}</th>,
          td: ({ children: c }) => <td className="px-3 py-2 border-t border-amber-50 align-top text-[12.5px] text-slate-700">{c}</td>,
          tr: ({ children: c }) => <tr className="even:bg-slate-50/50">{c}</tr>,
          ul: ({ children: c }) => <ul className="list-disc pl-5 my-2 space-y-1 marker:text-amber-500">{c}</ul>,
          ol: ({ children: c }) => <ol className="list-decimal pl-5 my-2 space-y-1 marker:font-bold marker:text-amber-600">{c}</ol>,
          li: ({ children: c }) => <li className="pl-0.5">{c}</li>,
          h1: ({ children: c }) => <h3 className="font-extrabold text-base mt-3 mb-1.5 text-slate-900">{c}</h3>,
          h2: ({ children: c }) => <h3 className="font-extrabold text-[14.5px] mt-3 mb-1.5 text-slate-900">{c}</h3>,
          h3: ({ children: c }) => <h4 className="font-bold text-sm mt-2.5 mb-1 text-slate-800">{c}</h4>,
          p: ({ children: c }) => <p className="my-1.5">{c}</p>,
          strong: ({ children: c }) => <strong className="font-bold text-slate-900">{c}</strong>,
          hr: () => <hr className="my-3 border-slate-100" />,
          blockquote: ({ children: c }) => <blockquote className="border-l-4 border-amber-300 bg-amber-50/60 pl-3 pr-2 py-1.5 my-2.5 rounded-r-xl">{c}</blockquote>,
          pre: ({ children: c }) => <div className="my-1">{c}</div>,
          code: ({ className, children: c }) => {
            if ((className || "").includes("language-chart")) return <AIChart raw={String(c || "").trim()} />;
            if ((className || "").startsWith("language-")) return <pre className="bg-slate-100 rounded-lg p-2 text-[11.5px] overflow-x-auto whitespace-pre-wrap"><code>{c}</code></pre>;
            return <code className="bg-slate-100 rounded px-1 text-[12px]">{c}</code>;
          },
  }), [onImage, onOpenDoc]);
  return (
    <div className="ai-md text-[13.5px] leading-relaxed text-slate-700 break-words">
      <ReactMarkdown
        remarkPlugins={REMARK}
        components={components}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
